export interface SecurityReportProps {
  startDate: string;
  endDate: string;
  notLoadedMode: string;
  rerender: boolean;
  ref?: any;
  onRow: any;
}

export interface DirectorReportProps {
  startDate: string;
  endDate: string;
  rerender: boolean;
  notLoadedMode: string;
  ref?: any;
  onRow: any;
}

export enum SecurityReportTypes {
  unloading = 'Історія проходу ТЗ: розвантаження',
  loading = 'Історія проходу ТЗ: завантаження',
  report2359 = 'Звіт 2359',
  specialList = 'Чорний список',
}

export enum DirectorReportTypes {
  unloading = 'Історія проходу ТЗ: розвантаження',
  loading = 'Історія проходу ТЗ: завантаження',
  report2359 = 'Звіт 2359',
  specialList = 'Чорний список',
}

export enum OrderReportTypes {
  unloading = 'Історія проходу ТЗ: розвантаження',
  loading = 'Історія проходу ТЗ: завантаження',
  report2359 = 'Звіт 2359',
  specialList = 'Чорний список',
}

export enum TripStatuses {
  trip0 = 'Всі',
  trip1 = 'I Новий рейс',
  trip2 = 'II На парковці, в черзі на виписку',
  trip3 = 'III Очікує завантаження',
  trip4 = 'IV На завантаженні',
  trip5 = 'V На парковці, оформлення',
  trip6 = 'VI Очікує виїзд',
  trip7 = 'VII На паузі',
  trip8 = 'VIII Очікує завсклада',
  trip9 = 'IX Без документів',
  trip99 = 'IC Виїхала',
}

export enum RolesReportTypes {
  visitor = 'Відвідувач',
  transport = 'Транспорт',
  all = 'Всі',
}
